import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import '../styles/index.scss';

const ArrowIcon = ({className, direction}) => {
  return <div className={cx('arrow-icon', `arrow-icon--${direction}`, className)} />;
};

ArrowIcon.propTypes = {
  /**
   * Custom class name to add to the icon
   */
  className: PropTypes.string,

  /**
   * Arrow direction
   */
  direction: PropTypes.oneOf(['left', 'right', 'up', 'down']).isRequired,
};

export default ArrowIcon;
